import { render, staticRenderFns } from "./item.vue?vue&type=template&id=d0fa8f2c&"
import script from "./item.ts?vue&type=script&lang=js&"
export * from "./item.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports